"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("The logo was not clicked in time"));
    }, 3000);
});
function showMessage(text) {
    var isError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var div = document.createElement("div");
    div.classList.add("message");
    if (isError) div.classList.add("error-message");
    div.textContent = text;
    document.body.appendChild(div);
}
promise1.then(function() {
    return showMessage("Promise was resolved!");
});
promise2.catch(function() {
    return showMessage("Promise was rejected!", true);
});

//# sourceMappingURL=index.df962976.js.map
